
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
const meta = {};
const slug = '_growingstore';
const tableOfContents = [{
  "title": "------",
  "slug": "",
  "children": [{
    "title": "SEO",
    "slug": "seo",
    "children": []
  }, {
    "title": "Email Tools",
    "slug": "email-tools",
    "children": []
  }, {
    "title": "Advertising Tools",
    "slug": "advertising-tools",
    "children": []
  }, {
    "title": "Analytical Tools",
    "slug": "analytical-tools",
    "children": []
  }, {
    "title": "Feedback & Survey Tools",
    "slug": "feedback-and-survey-tools",
    "children": []
  }, {
    "title": "Promotion / Popup tools",
    "slug": "promotion-popup-tools",
    "children": []
  }]
}];

const layoutProps = {
  meta,
slug,
tableOfContents
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <_Heading level={2} id={""} nextElement={{
      "type": "paragraph"
    }}>------</_Heading>
    <p>{`On top of Tradly Free Creator tools. You can add 3rd party apps inside your store for further faetures. `}</p>
 <div class="relative">
        <img class="w-full  h-82 object-cover rounded-lg shadow-lg" src="/img/webintegrations.png" />
      </div>
    <_Heading level={3} id={"seo"} nextElement={{
      "type": "paragraph"
    }}>SEO</_Heading>
    <p>{`SEO (Structured card image) & Search engine listing preview, `}</p>
    <_Heading level={3} id={"email-tools"} nextElement={{
      "type": "paragraph"
    }}>Email Tools</_Heading>
    <p>{`Integrating your online store with Marketing Tools (especially Mailchimp for emails) `}</p>
    <_Heading level={3} id={"advertising-tools"} nextElement={{
      "type": "paragraph"
    }}>Advertising Tools</_Heading>
    <p>{`Your hosted website can add integrations to run ads. Example: Facebook Pixel, Google Ads Conversion Pixel can be added through Native integrations. or you can use Google Tag Manager integration to do advanced pixel placement in specific pages or custom trigger condition. `}</p>
    <_Heading level={3} id={"analytical-tools"} nextElement={{
      "type": "paragraph"
    }}>Analytical Tools</_Heading>
    <p>{`Connect with Analytical Tools (like Google Analytics) `}</p>
    <_Heading level={3} id={"feedback-and-survey-tools"} nextElement={{
      "type": "paragraph"
    }}>Feedback & Survey Tools</_Heading>
    <p>{`Connecting with Feedback & UX monitoring tools (like Hotjar, clarity) (By default, we have feedback form) `}</p>
    <_Heading level={3} id={"promotion-popup-tools"} nextElement={{
      "type": "paragraph"
    }}>Promotion / Popup tools</_Heading>
    <p>{`Connecting Promotion / Popup tools`}</p>
    <p>{`Advanced Growth Tactics`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Increase AOV by setting up minimum purchase `}</li>
      <li parentName="ul">{`Create Collection pages to get more exposure in Google Search results or thematic celebrations. `}</li>
    </ul>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
